// 手机端展开长信息并让表单/操作换行，避免联系人、通知内容和相机错误提示超出屏幕；桌面保留原排布。
import React, { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { X, Camera } from "lucide-react";

/* 手机/电脑摄像头连续扫码（html5-qrcode）；同一码 1.5s 内去重 */
export const CameraScanner = ({ onDecode, onClose, zh }) => {
  const [err, setErr] = useState("");
  const [last, setLast] = useState("");
  const lastRef = useRef({ text: "", at: 0 });
  useEffect(() => {
    if (!document.getElementById("wms-cam-reader")) return undefined;
    const s = new Html5Qrcode("wms-cam-reader", { verbose: false });
    let alive = true;
    s.start({ facingMode: "environment" }, { fps: 10, qrbox: (w, h) => { const m = Math.min(w, h, 340); return { width: m * 0.8, height: m * 0.8 }; } },
      (text) => {
        const now = Date.now();
        if (text === lastRef.current.text && now - lastRef.current.at < 1500) return;
        lastRef.current = { text, at: now };
        setLast(text);
        onDecode(text, "camera");
      }, () => {}).catch((e) => { if (alive) setErr(String(e?.message || e)); });
    return () => { alive = false; s.stop().then(() => s.clear()).catch(() => {}); };
  }, []); // eslint-disable-line
  return (
    <div className="fixed inset-0 z-[70] bg-black/80 flex items-center justify-center p-3" data-testid="wms-camera-modal" onClick={onClose}>
      <div className="bg-slate-900 rounded-2xl w-full max-w-md max-h-[90dvh] overflow-y-auto shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-2.5 text-white text-sm">
          <span className="inline-flex items-center gap-1.5 font-semibold"><Camera className="h-4 w-4" />{zh ? "摄像头扫码 · 连续识别" : "Camera scan"}</span>
          <button type="button" data-testid="wms-camera-close" onClick={onClose} aria-label={zh ? "关闭摄像头" : "Close camera"} className="h-11 w-11 shrink-0 inline-flex items-center justify-center text-slate-300 hover:text-white"><X className="h-4 w-4" /></button>
        </div>
        <div id="wms-cam-reader" className="w-full min-h-[240px]" />
        {err
          ? <p className="p-3 text-xs text-red-300 break-words" data-testid="wms-camera-error">{zh ? "无法打开摄像头：" : "Camera error: "}{err}{zh ? "（需 HTTPS 且允许摄像头权限）" : ""}</p>
          : <p className="p-3 text-[11px] text-slate-300 break-all" data-testid="wms-camera-last">{last ? `${zh ? "最近识别" : "Last"}: ${last}` : (zh ? "对准二维码，识别后自动加入清单，可连续扫描" : "Point at a QR code; scans are added automatically")}</p>}
      </div>
    </div>
  );
};
